var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import FSButton from '../components/FSButton';
import eventEmiter from './Emitter';
import { useLanguage } from './LanguageProvider';
import SignInActions from './SignInActions';
function Unauthorized(props) {
    var L = useLanguage().L;
    if (props.path.includes('entrylink')) {
        return (React.createElement("div", { className: "global-error" },
            React.createElement("div", { className: "global-error-content" },
                React.createElement("h2", null, L('Invalid link.')),
                React.createElement("p", null, L('Link does not exist.')))));
    }
    return (React.createElement("div", { className: "global-error" },
        React.createElement("div", { className: "global-error-content" },
            React.createElement("h2", null, L('Access not granted to host.')),
            React.createElement("p", null, L('Please contact your administrator for more information.')),
            React.createElement(FSButton, { title: L('Logout'), onClick: function () { return SignInActions.signOut(); } }))));
}
export function UnauthorizedWrapper(props) {
    var _this = this;
    var _a;
    var _b = __read(useState(false), 2), requestUnauthorized = _b[0], setRequestUnauthorized = _b[1];
    var location = useLocation();
    useEffect(function () {
        var unauthorizedHandler = function (unauthorized) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setRequestUnauthorized(unauthorized);
                return [2 /*return*/];
            });
        }); };
        eventEmiter.on('unauthorized', unauthorizedHandler);
        return function () {
            eventEmiter.off('unauthorized', unauthorizedHandler);
        };
    }, []);
    if (requestUnauthorized) {
        return React.createElement(Unauthorized, { path: location.pathname });
    }
    return React.createElement(React.Fragment, null, (_a = props === null || props === void 0 ? void 0 : props.children) !== null && _a !== void 0 ? _a : null);
}
